import { useEffect, useState } from "react";
import axiosInstance from "../../api/axios";
import toast from "react-hot-toast";
import { Loader2 } from "lucide-react";
import CertificateUploader from "../../components/certfications-uploader/CertficationsUploader";

export default function Certifications() {
    const [certificates, setCertificates] = useState({ fa: null, en: null });
    const [loading, setLoading] = useState(false);

    const fetchCertificates = async () => {
        setLoading(true);
        try {
            const [faRes, enRes] = await Promise.allSettled([
                axiosInstance.get("/api/certificate/get-list-admin", { params: { is_english: false } }),
                axiosInstance.get("/api/certificate/get-list-admin", { params: { is_english: true } }),
            ]);

            setCertificates({
                fa:
                    faRes.status === "fulfilled" && faRes.value.data?.data[0]
                        ? faRes.value.data.data[0]
                        : null,
                en:
                    enRes.status === "fulfilled" && enRes.value.data?.data[0]
                        ? enRes.value.data.data[0]
                        : null,
            });
        } catch (err) {
            toast.error("خطا در دریافت اطلاعات گواهینامه‌ها");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCertificates();
    }, []);

    if (loading)
        return (
            <div className="flex justify-center items-center gap-1.5 h-[60vh] text-background">
                <Loader2 strokeWidth={1.5} className="text-black/70 animate-spin mr-2" />
                در حال دریافت اطلاعات...
            </div>
        );

    return (
        <section className="w-full flex flex-col justify-start items-start gap-6 max-w-4xl mx-auto">
            <h2 className="text-xl font-semibold text-background py-3">مدیریت گواهینامه‌ها</h2>

            <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-6">
                <CertificateUploader
                    title="گواهینامه‌های فارسی"
                    certificate={certificates.fa}
                    isEnglish={false}
                    onChange={fetchCertificates}
                />
                <CertificateUploader
                    title="گواهینامه‌های انگلیسی"
                    certificate={certificates.en}
                    isEnglish={true}
                    onChange={fetchCertificates}
                />
            </div>
        </section>
    );
}